import * as Sentry from '@sentry/angular';
import jwt_decode from 'jwt-decode';

const logJwtDecodeFailure = (fn: string, error: unknown): void => {
    Sentry.addBreadcrumb({
        category: 'jwt.helper',
        message: `Failed to decode access token in ${fn}`,
        level: 'warning',
        data: { error: error instanceof Error ? error.message : String(error) },
    });
};

export const getRolesFromToken = (accessToken) => {
    if (!accessToken) {
        return null;
    }
    try {
        const jwtPayload: any = jwt_decode(accessToken);
        if (jwtPayload && jwtPayload.saras_claims) {
            return jwtPayload.saras_claims;
        } else {
            return null;
        }
    } catch (error) {
        logJwtDecodeFailure('getRolesFromToken', error);
        return null;
    }
}

export const getUserIdFromToken = (accessToken) => {
    if (!accessToken) {
        return null;
    }
    try {
        const jwtPayload: any = jwt_decode(accessToken);
        if (jwtPayload && jwtPayload.user_id) {
            return jwtPayload.user_id;
        } else {
            return null;
        }
    } catch (error) {
        logJwtDecodeFailure('getUserIdFromToken', error);
        return null;
    }
}

/**
 * Best-effort `{ email, firstName, lastName }` from the token's own claims. Used when a
 * session starts without the `user` handoff param (local iQ cookie sign-in).
 */
export const getUserInfoFromToken = (
    accessToken: string | null | undefined
): { email: string; firstName: string; lastName: string } | null => {
    if (!accessToken) {
        return null;
    }
    try {
        const jwtPayload = jwt_decode<{ email?: string; name?: string }>(accessToken);
        const [firstName = '', ...rest] = String(jwtPayload?.name || '').split(' ');
        return {
            email: jwtPayload?.email || '',
            firstName,
            lastName: rest.join(' '),
        };
    } catch (error) {
        logJwtDecodeFailure('getUserInfoFromToken', error);
        return null;
    }
}
